/**
 * メンバーページ
 */
import styles from './Members.module.css';
import headerBg from '../../assets/images/武蔵野大学.jpg';

function Members() {
  return (
    <div className={styles.container}>
      <header className={styles.homeHeader}>
        <img
          src={headerBg}
          alt="武蔵野大学"
          className={styles.headerImage}
        />
        <div className={styles.headerOverlay}>
          <h1 className={styles.headerTitle}>Members</h1>
        </div>
      </header>

      <main className={styles.mainContent}>
        <div className={styles.underConstruction}>
          <h2 className={styles.heading}>Coming Soon</h2>
          <p className={styles.message}>
            現在準備中です。<br />
            公開まで今しばらくお待ちください。
          </p>
        </div>
      </main>
    </div>
  );
}

export default Members;
